import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatBadge } from '@angular/material/badge'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs'
import {
  ElderPaneContentComponent,
  ElderPaneSubtitleComponent,
  ElderValidationErrorDirective,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject, Observable } from 'rxjs'
import { ConstraintTableComponent } from '../../../shopfloor/workcenters/capability/constraints/constraint-table/constraint-table.component'
import { PropertyConfTableComponent } from '../../conf/property-conf-table/property-conf-table.component'
import { DynamicPropertyConf } from '../dynamic-property-conf'

@Component({
  selector: 'app-dynamic-property-conf-detail',
  templateUrl: './dynamic-property-conf-detail.component.html',
  styleUrls: ['./dynamic-property-conf-detail.component.scss'],
  imports: [
    ElderPaneContentComponent,
    ElderPaneSubtitleComponent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatError,
    ElderValidationErrorDirective,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatBadge,
    ConstraintTableComponent,
    PropertyConfTableComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class DynamicPropertyConfDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _conf$ = new BehaviorSubject<DynamicPropertyConf>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get conf$(): Observable<DynamicPropertyConf> {
    return this._conf$.asObservable()
  }

  public get conf(): DynamicPropertyConf {
    return this._conf$.getValue()
  }

  @Input()
  public set conf(conf: DynamicPropertyConf) {
    this._conf$.next(conf)
  }
}
